// Home. On a phone it is the iOS home list; on a desk the same list stands
// as the rail and the pinboard takes the stage.
import { Workbench, useDesk } from '../../shell/Workbench';
import { HomeList } from './HomeList';
import { Pinboard } from './Pinboard';
import { homeScreen } from '../../onboarding/standIn';

export default function HomeRoute() {
  const desk = useDesk();
  return <Workbench>{desk ? <Pinboard /> : <HomeList />}</Workbench>;
}

// The tour shows this same screen on its home beats.
homeScreen.set(() => <HomeRoute />);
